<div id="rc-dialog-content">
  @switch (dialogInputData.usage) {
    @case ('cq-table-row') {
      <gd-cq-table-rc-dialog
        [item]="dialogInputData.item"
        [contentType]="dialogInputData.contentType"
      (closeDialog)="close()"></gd-cq-table-rc-dialog>
    }
  }
</div>
